import { combineReducers } from 'redux'
import { SET_ADDRESS_VALIDATED, SET_ADDRESS_LIST, SET_ADDRESS_DETAILS } from '../constants'
const defaultShippingAddress = {
  firstName: '',
  lastName: '',
  addressLine1: '',
  addressLine2: '',
  addressLine3: '',
  province: '',
  country: 'Canada',
  postalCode: '',
}

const shipping = (state = defaultShippingAddress, { type, payload }) => {
  switch (type) {
    case SET_ADDRESS_DETAILS:
      return payload
    default:
      return state
  }
}
const isBillingSameAsShipping = (state = true, action) => {
  switch (action.type) {
    case 'IS_BILLING_SAME_AS_SHIPPING':
      return true
    default:
      return state
  }
}
const isAddressValidated = (state = false, { type, payload }) => {
  switch (type) {
    case SET_ADDRESS_VALIDATED:
      return payload
    default:
      return state
  }
}

const matchedAddresses = (state = [], { type, payload }) => {
  switch (type) {
    case SET_ADDRESS_LIST:
      return payload
    default:
      return state
  }
}

export const addressReducer = combineReducers({
  shipping,
  isBillingSameAsShipping,
  isAddressValidated,
  matchedAddresses,
})



// WEBPACK FOOTER //
// ./src/containers/Cart/Address/addressReducer.js